import React from "react";
import { StoryEditor } from "@/components/myWriting";

export default function StoryEditorPage() {
  return <StoryEditor />;
}
